import { useNavigate, useParams } from "react-router-dom";
import * as L from "leaflet";

import { Pane } from "src/components/Pane";
import { LEZCreatePage } from "./LEZCreatePage";
import { LEZEditPage } from "./LEZEditPage";

interface Props {
  map: L.Map;
}

export function LEZPage(props: Props) {
  const navigate = useNavigate();
  const params = useParams<{
    caseId: string;
    scenarioId: string;
    lezId: string;
  }>();
  function handleClose() {
    navigate(`/cases/${params.caseId}/scenarios/${params.scenarioId}/lezs`);
  }

  return render();

  function render() {
    if (params.lezId === "new") {
      return (
        <Pane>
          <LEZCreatePage onClose={handleClose} {...props} />
        </Pane>
      );
    }
    return (
      <Pane>
        <LEZEditPage key={[params.caseId, params.scenarioId, params.lezId].join()} onClose={handleClose} {...props} />
      </Pane>
    );
  }
}
